
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return require("private-next-pages/search/index.tsx");
      }
    ]);
  